const ObjectsSEO = () => {
  return (
    <section className="block zero">
      <div className="fixed">
        <p>
          Определение этого понятия у многих вызывает затруднение. Большинство неверно истолковывают
          термин.
        </p>
        <p>
          Вторичной считается любая недвижимость, которая уже является чьим-то имуществом. При этом
          не важно, когда было построено, сдано здание. Речь не только о старом фонде. Первичное
          жилье становится таковым сразу же после государственной регистрации. Даже если застройщик
          до окончания строительства не продал его, оформив на себя, оно не будет считаться
          первичным.
        </p>
        <p>Продавцом могут выступать:</p>
        <ul>
          <li>Строительные учреждения;</li>
          <li>Государство;</li>
          <li>Частные лица;</li>
        </ul>
        <p>
          Большинство подобной недвижимости продается в достроенных домах, развитых районах.
          Помещениям, как правило, не требуется а, въехать, прописаться можно сразу же. Квартиры,
          которые купили на вторичном рынке занимают первое место по популярности. Однако нюансов
          оформления множество: от наличия нескольких собственников до незаконных перепланировок.
          Предоставить наилучшее решение покупки вторичного жилья (квартиры) Ростова-на-Дону и
          области смогут опытные специалисты «ЛЕНДЛОРД».
        </p>
        <h2>О фирме</h2>
        <p>
          Организация обладает 32-летним опытом работы. От конкурентов ее отличает комплексный
          подход в решении риелторских вопросов.
        </p>
        <p>
          Сегодня открыто 7 филиалов, штат составляет более 120 агентов, помогающих оформить
          операции купли-продажи квартир на вторичном рынке.
        </p>
        <p>
          Организация получила признание профессиональной среды. Подтверждение тому – десятки наград
          на отечественных, международных конкурсах.
        </p>
        <p>
          Почему выбирают нас, когда хотят купить дом в Ростове-на-Дону, вторичное жилье в области?
        </p>
        <ul>
          <li>
            <i>Внушительная база</i>
            <p>
              Каталог содержит около 8000 наименований. При этом можно найти подходящий объект
              любого сегмента: от эконома до премиум.
            </p>
          </li>
          <li>
            <i>Быстрый поиск</i>
            <p>
              Сайт предоставляет возможность воспользоваться открытой базой. Встроенный поисковый
              сервис с фильтрами по категориям поможет легко найти предпочтительные варианты, узнать
              цену квартир Ростова-на-Дону, вторички Аксая и других населенных пунктов донского
              региона.
            </p>
          </li>
          <li>
            <i>Полное сопровождение</i>
            <p>
              Нами предоставляется персональный менеджер. Он помогает не только на этапе изучения
              объявлений, но также при оформлении документов, вплоть до заключения договора на
              приобретение недвижимости в Ростове-на-Дону, вторички других регионов.
            </p>
          </li>
          <li>
            <i>Контроль качества сервиса</i>
            <p>
              Сотрудники работают по установленным регламентам. Отхождение от них, возникшие спорные
              ситуации разрешаются специальным отделом качества.
            </p>
          </li>
          <li>
            <i>Решение рутинных вопросов</i>
            <p>
              Мы предоставляем возможность клиентам сохранить личное время. Дела, связанные с
              поиском, оценкой, подготовкой документации, берем на себя. Помогаем купить студию,
              вторичное жилье недорого.
            </p>
          </li>
          <li>
            <i>Бесплатные консультации</i>
            <p>
              По телефону или при личной встрече можно побеседовать с узкими специалистами. Они
              проведут первичное изучение ситуации без дополнительной платы, предоставят
              рекомендации юридического характера или касающиеся взятия кредита.
            </p>
          </li>
          <li>
            <i>Проверенные объявления</i>
            <p>
              Компания тщательно изучает объекты, продавцов. Каждое объявление, размещенное на сайте
              или закрытом каталоге, прошло проверку, касающуюся юридических аспектов. Здесь можно
              узнать точно, сколько стоит вторичное жилье в Ростове.
            </p>
          </li>
          <li>
            <i>Безопасность сделок</i>
            <p>
              Агентство оценивает инвестиционную привлекательность недвижимого имущества, рыночную
              стоимость, юридические аспекты до подписания договора. Продавцы, покупатели получают
              всю информацию о продаже квартир, вторички Батайска, близлежащих городов, поселков.
              При непредвиденных обстоятельствах клиенты могут воспользоваться гарантийным
              сертификатом номиналом до 6 миллионов рублей. Его можно обналичивать на возмещение
              реально понесенного ущерба.
            </p>
          </li>
          <li>
            <i>Удобное расположение офисов</i>
            <p>
              Они находятся в нескольких районах донской столицы: два – в центральной части города,
              по одному – в Нахичевани, Военведе, Западном, Северном жилых массивах. Также работают
              два новочеркасских офиса продажи квартир (вторичка): в Центре, Октябрьском районе.
            </p>
          </li>
        </ul>
        <h2>Услуги</h2>
        <p>
          Направления деятельности носят комплексный характер. Покупателям, продавцам доступно
          риелторское, юридическое сопровождение, брокерское содействие.
        </p>
        <h2>Поиск на вторичном рынке жилья в Ростове-на-Дону</h2>
        <p>
          Купить апартаменты или коттедж помогут наши менеджеры. Они подберут варианты с учетом
          потребностей, финансовых возможностей клиента, договорятся о просмотре с владельцем,
          изучат правовые тонкости соглашения, составят персонализированную стратегию купли-продажи.
        </p>
        <p>
          Также можно воспользоваться открытым каталогом объектов. Здесь собраны последние свежие
          объявления продажи квартир на «вторичке».
        </p>
        <p>Доступные локации:</p>
        <ul>
          <li>Ростов-на-Дону;</li>
          <li>Аксай;</li>
          <li>Кривянская;</li>
          <li>Персиановский;</li>
          <li>Казачьи лагери;</li>
          <li>Заплавская;</li>
          <li>Багаевская;</li>
          <li>Малая Гнилуша и другие;</li>
        </ul>
        <p>
          Расширенная база содержит объявления о срочной продаже квартир Ростова. Вторичка, которую
          необходимо продать быстро, отличается более низкой стоимостью. Многие сервисы предлагают
          подобное, но говорить о надежности «выгодных» предложений нельзя. За ними часто стоят
          мошенники. Наши агенты проверяют все объявления, что позволяет купить квартиру в
          Ростове-на-Дону, в Азове, в Новочеркасске, в Батайске (вторичка) недорого, без ущерба.
        </p>
        <h2>Оценка</h2>
        <p>
          Мы определяем рыночную стоимость, характеристики помещения, правовые аспекты для
          оформления купли-продажи, страхования, разделения имущества, кредитования, вступления в
          права наследства.
        </p>
        <h2>Сопровождение</h2>
        <p>
          Проводим переговоры, консультации обеих сторон соглашения, разрабатываем оптимальное
          решение сложных ситуаций, споров, подготавливаем необходимую документацию, чтобы купить
          квартиру в Ростовской области (вторичное жилье) в рамках правового поля. Также помогаем
          получить право на собственность и зарегистрировать покупку.
        </p>
        <h2>Ипотечное кредитование</h2>
        <p>
          Наши клиенты могут получить помощь в оформлении ипотеки. Первоначальный взнос не
          требуется. Брокеры изучат условия банков, предложат наиболее удачные варианты, отправят
          заявки. Для подачи запроса потребуется два документа. При этом не важно, устроены ли вы
          официально на работе. Рассмотрение занимает не больше 24 часов. После ответа, можно сразу
          купить квартиру (вторичное жилье). Центр ипотечного кредитования «ЛЕНДЛОРД» найдет выход
          из ситуации, даже если у вас недостаточно хорошая кредитная история.
        </p>
        <p>Сотрудничество осуществляется со следующими финансовыми организациями:</p>
        <ul>
          <li>Россельхозбанк;</li>
          <li>Газпромбанк;</li>
          <li>Росбанк;</li>
          <li>Сбербанк;</li>
          <li>ВТБ;</li>
          <li>Абсолют;</li>
          <li>Центр-Инвест;</li>
          <li>Транскапиталбанк;</li>
        </ul>
      </div>
    </section>
  );
};

export default ObjectsSEO;
